// Basic info modal with the hourly fee select, visibility toggle and info box.
// Render standalone via /styleguide/c/ProfileSettingsBasicInfoForm/BasicInfo/raw.
import ProfileSettingsBasicInfoForm from './ProfileSettingsBasicInfoForm';

const noop = () => null;

export const BasicInfo = {
  component: ProfileSettingsBasicInfoForm,
  props: {
    isOpen: true,
    onClose: noop,
    onManageDisableScrolling: noop,
    onSubmit: noop,
    location: null,
    languages: ['finnish', 'english', 'swedish'],
    hourlyFee: '60-79 / h',
    dontShowHourlyFee: false,
    languageOptions: [
      { key: 'finnish' },
      { key: 'english' },
      { key: 'swedish' },
      { key: 'german' },
    ],
    updateInProgress: false,
    hideHourlyFee: false,
  },
  group: 'forms',
};
